import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AddressAutocompleteComponent } from 'src/app/common/address-autocomplete/address-autocomplete.component';
import { ToolbarModule } from 'primeng/toolbar';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabViewModule } from 'primeng/tabview';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SubscriptionsModule } from '../subscriptions/subscriptions.module';
import { AdminRoutingModule } from './admin.routes';
import { ApplicationLogComponent } from 'src/app/components/admin-level/all-galleries/application-log/application-log.component';
import { ArtTypeComponent } from 'src/app/components/admin-level/art-type/art-type.component';
import { EmailSettingsComponent } from 'src/app/components/admin-level/email-settings-template/email-settings.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ChartModule } from 'primeng/chart';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { GalleriesComponent } from 'src/app/components/admin-level/all-galleries/galleries.component';
import { SafeHtmlPipe } from 'src/app/pipes/safeHtml.pipe';
import { ViewGalleryAddressComponent } from 'src/app/components/admin-level/view-gallery-address/view-gallery-address.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { GalleryStaffComponent } from 'src/app/components/admin-level/gallery-staff/gallery-staff.component';
import { TreeModule } from 'primeng/tree';
import { BaseModule } from 'src/app/models/base/base.module';
import { StepsModule } from 'primeng/steps';
import { SubscriptionRulesComponent } from 'src/app/components/admin-level/subscription-rules/subscription-rules.component';
import { SystemSettingsComponent } from 'src/app/components/admin-level/system-settings/system-settings.component';
import { AccordionModule } from 'primeng/accordion';
import { AdminsComponent } from 'src/app/components/admin-level/admins/admins.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SystemEventsWorkflowComponent } from 'src/app/components/admin-level/System-Events-Workflow/system-events-workflow.component';
import { SidebarModule } from 'primeng/sidebar';
import { EmailEventDailogComponent } from 'src/app/components/admin-level/email-event-dailog/email-event-dailog.component';
import { EmailEventComponent } from 'src/app/components/admin-level/email-events/email-events.component';
import { EmailSettingTemplateDailogComponent } from 'src/app/components/admin-level/email-setting-template-dailog/email-setting-template-dailog.component';
import { ArtistViewProfileComponent } from 'src/app/components/artist-components/view-artist-profile/view-artist-profile.component';
import { SiteViewComponent } from 'src/app/components/artist-components/website-builder/site-view/site-view.component';
import { ProductDetailsDialogComponent } from 'src/app/common/product-details-dialog/product-details-dialog.component';
import { GalleryProposalComponent } from 'src/app/components/gallery-components/gallery-proposal/gallery-proposal.component';
import { ProposalSelectionComponent } from 'src/app/components/gallery-components/proposal-selection/proposal-selection.component';
import { ArtistOverlayComponent } from 'src/app/components/artist-components/artist-overlay/artist-overlay.component';
import { ArtistProductTileComponent } from 'src/app/components/artist-components/artist-product-tile/artist-product-tile.component';
import { DsSharedModule } from 'src/app/common/ds-shared.module';
import { ArtistInsightsChartComponent } from 'src/app/components/artist-components/artist-insights-chart/artist-insights-chart.component';
import { ProductShareDailogComponent } from 'src/app/common/product-share/product-share.component';
import { SMSSettingsComponent } from 'src/app/components/admin-level/sms-settings/sms-settings.componenet';
import { ApiKeysComponent } from 'src/app/components/admin-level/api-keys/api-keys.component';
import { SMSSettingTemplateDailogComponent } from 'src/app/components/admin-level/sms-setting-template-dailog/sms-setting-template-dailog.component';
import { SMSEventDailogComponent } from 'src/app/components/admin-level/sms-event-dailog/sms-event-dailog.component';
import { TermsAcceptanceDialogComponent } from 'src/app/components/artist-components/view-consignment/terms-acceptance-dialog/terms-acceptance-dialog.component';
import { TranslocoModule } from '@jsverse/transloco';
@NgModule({ declarations: [
        SafeHtmlPipe, ViewGalleryAddressComponent, SubscriptionRulesComponent, ArtistViewProfileComponent,
        SystemSettingsComponent, AdminsComponent, SystemEventsWorkflowComponent,
        ApplicationLogComponent, ArtTypeComponent, GalleriesComponent, EmailSettingsComponent, GalleryStaffComponent,
        EmailEventComponent,
        EmailEventDailogComponent,
        EmailSettingTemplateDailogComponent,
        SMSSettingTemplateDailogComponent,
        ProductDetailsDialogComponent,
        GalleryProposalComponent,
        ProposalSelectionComponent,
        ArtistOverlayComponent,
        ArtistProductTileComponent,
        ArtistInsightsChartComponent,
        ProductShareDailogComponent,
        SMSSettingsComponent,
        SMSEventDailogComponent,
        TermsAcceptanceDialogComponent,
        ApiKeysComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        ViewGalleryAddressComponent,
        GalleryStaffComponent,
        ArtistViewProfileComponent,
        ArtistOverlayComponent,
        ArtistProductTileComponent,
        ArtistInsightsChartComponent,
        ProductDetailsDialogComponent,
        ProductShareDailogComponent,
        TermsAcceptanceDialogComponent,
        SafeHtmlPipe,
    ], imports: [DsSharedModule, SiteViewComponent, AddressAutocompleteComponent, CommonModule, FormsModule, AdminRoutingModule, CommonModule, BaseModule, StepsModule, AccordionModule,
        AngularEditorModule, OverlayPanelModule, ChartModule, TableModule, ToastModule, ButtonModule, ConfirmDialogModule, AccordionModule,
        NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }), InputSwitchModule,
        DropdownModule, PanelModule, TabViewModule, ToolbarModule, CheckboxModule, DialogModule, FileUploadModule, MultiSelectModule,
        InputTextareaModule, SubscriptionsModule.forRoot(), TreeModule, SidebarModule, TranslocoModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AdminModule {
    static forRoot(): ModuleWithProviders<AdminModule> {
        return {
            ngModule: AdminModule
        };
    }
}
